async function insertNewUserToServer(params) {
  try {
    let response = await fetch('https://sheet.best/api/sheets/70f40af6-1fe5-49e4-9b13-561f25d91a74', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params)
    });
    let responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.error(`Error is : ${error}`);
  }
}
export { insertNewUserToServer };
